import React from 'react';

import {
  SearchComponent,
  ISearchComponent,
} from '../../core/components/SearchComponent';

import lineModules from '../../core/components/lineModules'
import { Container } from './styles';
import { useParams } from 'react-router-dom';

interface ValidationRules {
  type: 'email' | 'required' | 'min' | 'max' | 'length';
  message?: string;
  quantity?: number;
}

interface ValidationSchema {
  name: string;
  type: 'string' | 'number' | 'boolean';
  label: string;
  rules: Array<ValidationRules>;
}

interface ILine {
  [key: string]: string;
}     
interface IParams {
  projectHash : string;
  eventHash : string;
}

interface IParams {
  projectHash : string;
  eventHash : string;
}

const Dashboard: React.FC = () => {
  const endpoint = '/video-gallery';
  const title = 'Galeria de vídeos';
  
    const {projectHash, eventHash } = useParams<IParams>(); const schema: Record<string, any> = {
    _id: { ref: '_id', column: '_id', label: 'ID', show: false },
  
    title: { ref: 'title', column: 'title', label: 'Expositor' },
   
    status: {
      ref: 'status',
      column: 'status_response',
      includeColumn: 'title',
      label: 'Status',
      filter: true,
    },
    createdAt: {
      ref: 'created_at',
      column: 'createdAt',
      label: 'Data de Criação',
      mask: 'date',
    },
  };

  const formSchema = {
   
    title: { model: 'input', type: 'text', name: 'title', label: 'Título' },
   
    status: {
      alias: 'status',
      model: 'selectApi',
      name: 'status',
      label: 'status',

      endpoint,
    },
   videos: {
      model: 'jsonListMultiple',
      type: 'text',
      name: 'videos',
      label: 'Galeria de Vídeos',
      list: {
        type_id: { label: 'Tipo', name: 'type_id' },
        title: { label: 'Título', name: 'title' },
        video_id: { label: 'ID do Vídeo', name: 'video_id' },
        chat_id: { label: 'ID Chat', name: 'chat_id' },
      },
    },
  };

  const formSchemaUpdate = {
    ...formSchema,

  };

  const formValidation: Record<string, ValidationSchema> = {

  };

  const config: ISearchComponent = {
    idKey : `${endpoint}-${projectHash}-${eventHash}`,
    title,
    endpoint,
    schema,
    autoStart: true,
    headModules: [
      () =>
      lineModules.create({
          title,
          formSchema,
          validationSchema: formValidation,
          endpoint,
        }),
    ],
    bodyModules: [
      (lineData: Record<string, any>) =>
        lineModules.updateUnique({
          lineData,
          title,
          formSchema: formSchemaUpdate,
          validationSchema: {},
          endpoint,
        }),
      (lineData: Record<string, any>) =>
        lineModules.delete({
          lineData,
          title,
          formSchema,
          validationSchema: formValidation,
          endpoint,
        }),
    ],
  };

  return (
    <Container>
      <SearchComponent {...config} />
    </Container>
  );
};

export default Dashboard;
